import { observer } from "mobx-react-lite";
import ControlGroup from "../../../../components/layouts/control-group/control-group";
import Card from "../../../../components/layouts/card/card";
import { SelectDropdown } from "../../../../components/inputs/select-dropdown/select-dropdown";
import AccountEditorStore from "../../stores/account-editor-store";
import { FormField } from "../../../../components/form-field/form-field";

interface IProps {
    account?: AccountEditorStore;
    disabled: boolean;
}
const AccountPermissionsCard: React.FC<IProps> = observer(({ account, disabled }) => {
    const accountRolesEditor = account?.accountRolesEditor;

    const storeRoleOptions = accountRolesEditor?.getStoreRoleOptions() ?? [];
    const selectedStoreRole = accountRolesEditor?.selectedStoreRole;
 
    const cRmaRoleOptions = accountRolesEditor?.getCRmaRolesOptions();
    const selectedCRmaRole = accountRolesEditor?.selectedCRmaRole;

    return (
        <Card
            toolbar={{
                title: "User Permissions"
            }}>
            <ControlGroup>
                <FormField label="Role">
                    <SelectDropdown
                        disabled={disabled}
                        value={selectedStoreRole}
                        options={storeRoleOptions}
                        onChange={accountRolesEditor?.setStoreRole}
                    />
                </FormField>
            </ControlGroup>

            {(cRmaRoleOptions && cRmaRoleOptions.length > 0) &&
                <ControlGroup>
                    <FormField label="RMA Creation Permissions">
                        <SelectDropdown
                            disabled={disabled || (accountRolesEditor?.hasPermissionAll() ?? true)}
                            value={selectedCRmaRole}
                            options={cRmaRoleOptions}
                            onChange={accountRolesEditor?.setCRmaRole}
                        />
                    </FormField>
                </ControlGroup>
            }
        </Card>
    );
});

export default AccountPermissionsCard;
